import DepressionEmail from './DepressionEmail';

export default DepressionEmail;
